import { render } from "./journalManage.vue?vue&type=template&id=3ab67e87"
import script from "./journalManage.vue?vue&type=script&lang=js"
export * from "./journalManage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__